import React, { useEffect } from "react";
import LegalLayout from "./LegalLayout";
import { useLanguage } from "../../i18n/LanguageContext";

const DatenschutzPage = () => {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = `${t("legal.datenschutz.title")} - Reflecta`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", t("legal.datenschutz.metaDescription"));
  }, [t]);

  return (
    <LegalLayout title={t("legal.datenschutz.title")}>
      <p>
        Diese Datenschutzerklärung informiert dich über die Verarbeitung
        personenbezogener Daten bei der Nutzung von Reflecta gemäß Art. 13
        DSGVO.
      </p>

      <h2 className="text-xl font-semibold mt-8">1. Verantwortlicher</h2>
      <p>
        Elaspix Unternehmergesellschaft (haftungsbeschränkt)
        <br />
        Schliffkopfstraße 25, 68163 Mannheim
        <br />
        E-Mail:{" "}
        <a href="mailto:info@elaspix.de" className="text-purple-700 hover:underline">
          info@elaspix.de
        </a>
      </p>

      <h2 className="text-xl font-semibold mt-8">2. Erhobene Daten und Zwecke</h2>

      <h3 className="text-base font-semibold mt-5">2.1 Registrierung und Konto</h3>
      <p>
        Bei der Registrierung erheben wir deine E-Mail-Adresse und ein
        Passwort. Diese Daten sind zur Vertragserfüllung (Bereitstellung des
        Nutzerkontos) erforderlich, Rechtsgrundlage ist Art. 6 Abs. 1 lit. b
        DSGVO. Optional kannst du einen Anzeigenamen sowie Zeitzone und
        Sprache in deinem Profil ergänzen.
      </p>

      <h3 className="text-base font-semibold mt-5">2.2 Tagebucheinträge und Ziele</h3>
      <p>
        Alle von dir verfassten Tagebucheinträge, Stimmungsangaben, Aktivitäten
        sowie deine Ziele werden in verschlüsselter Übertragung gespeichert.
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
        Diese Inhalte verlassen unsere Infrastruktur nur im Rahmen der
        KI-Verarbeitung (siehe Abschnitt 3).
      </p>

      <h3 className="text-base font-semibold mt-5">2.3 Chat-Nachrichten</h3>
      <p>
        Nachrichten im KI-Chat werden zur Beantwortung gespeichert. Bei
        kostenlosen Konten werden Chat-Nachrichten automatisch nach 90 Tagen
        gelöscht (technische TTL). Rechtsgrundlage ist Art. 6 Abs. 1 lit. b
        DSGVO.
      </p>

      <h3 className="text-base font-semibold mt-5">2.4 Protokolldaten</h3>
      <p>
        Zu Sicherheits- und Nachvollziehbarkeitszwecken speichern wir
        Audit-Logs (z. B. Kontoenstellungen, Datenlöschanfragen) für die Dauer
        von 5 Jahren. Rechtsgrundlage ist Art. 6 Abs. 1 lit. c DSGVO
        (rechtliche Verpflichtung) bzw. lit. f DSGVO (berechtigtes Interesse
        an der Sicherheit des Systems).
      </p>

      <h2 className="text-xl font-semibold mt-8">3. KI-Verarbeitung (Google Gemini)</h2>
      <p>
        Zur Bereitstellung der KI-Funktionen (Auswertung von
        Tagebucheinträgen, Chat-Assistent, Zielvorschläge) werden Inhalte an
        die Google LLC (USA) als Auftragsverarbeiter übermittelt. Google
        verarbeitet diese Daten ausschließlich zur Beantwortung der jeweiligen
        Anfrage; eine dauerhafte Speicherung auf Seiten von Google findet nicht
        statt.
      </p>
      <p className="mt-3">
        Die Übermittlung in die USA stützt sich auf die EU-Standardvertragsklauseln
        (Art. 46 Abs. 2 lit. c DSGVO) sowie auf deine ausdrückliche
        Einwilligung nach Art. 49 Abs. 1 lit. a DSGVO, die du bei der
        erstmaligen Nutzung der KI-Funktionen erteilst. Diese Einwilligung
        kannst du jederzeit mit Wirkung für die Zukunft widerrufen; die
        KI-Funktionen stehen danach nicht mehr zur Verfügung.
      </p>

      <h2 className="text-xl font-semibold mt-8">4. Hosting und Infrastruktur</h2>
      <p>
        Die Anwendung wird auf AWS-Infrastruktur betrieben. Alle
        personenbezogenen Daten werden ausschließlich in der AWS-Region
        <strong> eu-central-1 (Frankfurt, Deutschland)</strong> gespeichert.
        AWS ist als Auftragsverarbeiter gemäß Art. 28 DSGVO vertraglich
        gebunden.
      </p>

      <h2 className="text-xl font-semibold mt-8">5. Cookies und lokaler Speicher</h2>
      <p>
        Reflecta setzt keine HTTP-Cookies. Für den Betrieb der Anwendung
        werden folgende Einträge im lokalen Speicher deines Browsers
        (localStorage) abgelegt:
      </p>
      <ul className="list-disc ml-6 mt-2 space-y-1">
        <li>
          <strong>Session-Token</strong> — zur Aufrechterhaltung deiner
          Anmeldung, bis du dich abmeldest.
        </li>
        <li>
          <strong>Cookie-Einwilligung</strong> — deine Auswahl zu optionalen
          Funktionen, gültig für 12 Monate.
        </li>
        <li>
          <strong>Spracheinstellung</strong> — deine gewählte
          Anzeigesprache (DE/EN).
        </li>
      </ul>
      <p className="mt-3">
        Optionale Analyse- und Marketing-Funktionen sind derzeit nicht
        aktiviert. Sollten sie zukünftig eingesetzt werden, erfolgt dies nur
        mit deiner vorherigen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
      </p>

      <h2 className="text-xl font-semibold mt-8">6. Speicherdauer</h2>
      <p>
        Deine Daten werden gespeichert, solange dein Konto besteht. Nach
        Kontolöschung werden alle personenbezogenen Daten innerhalb von 30
        Tagen unwiderruflich gelöscht, soweit keine gesetzlichen
        Aufbewahrungspflichten entgegenstehen. Chat-Nachrichten im
        kostenlosen Tarif werden automatisch nach 90 Tagen gelöscht.
      </p>

      <h2 className="text-xl font-semibold mt-8">7. Deine Rechte</h2>
      <p>Dir stehen folgende Rechte zu:</p>
      <ul className="list-disc ml-6 mt-2 space-y-1">
        <li>Auskunft über gespeicherte Daten (Art. 15 DSGVO)</li>
        <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
        <li>Löschung deiner Daten (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        <li>Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
      </ul>
      <p className="mt-3">
        Zur Wahrnehmung deiner Rechte wende dich an{" "}
        <a href="mailto:info@elaspix.de" className="text-purple-700 hover:underline">
          info@elaspix.de
        </a>
        . Du hast außerdem das Recht, dich bei der zuständigen
        Datenschutzaufsichtsbehörde zu beschweren. Für Baden-Württemberg ist
        dies der Landesbeauftragte für den Datenschutz und die
        Informationsfreiheit (LfDI BW).
      </p>

      <h2 className="text-xl font-semibold mt-8">8. Datensicherheit</h2>
      <p>
        Die Übertragung zwischen deinem Browser und unseren Servern erfolgt
        verschlüsselt via TLS/HTTPS. Passwörter werden ausschließlich als
        gesicherter Hash gespeichert und sind für uns nicht einsehbar.
      </p>

      <p className="mt-8 text-sm text-gray-500">Stand: Juli 2026</p>
    </LegalLayout>
  );
};

export default DatenschutzPage;
